import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
@Injectable({
  providedIn: 'root'
})
export class CommonDownloadService {

  url5 = environment.serverAPI4 + "/api/order/download";

  url6 = environment.serverAPI4 + "/api/order/product/download";

  url7 = environment.serverAPI4 + "/api/order/gst/download";

  url16 = environment.serverAPI9 + "/api/builder/download";

  url17 = environment.serverAPI9 + "/api/housingbuilder/download";

  url18 = environment.serverAPI9 + "/api/housinglocation/download";

  url20 = environment.serverAPI5 + "/api/posUsers";

  url19 = environment.serverAPI4 + "/api/supplier/download";

  url25 = environment.serverAPI4 + "/api/loannowisereport";

  url26 = environment.serverAPI4 + "/api/userMailConfig";

  url27 = environment.serverAPI6 + "/api/projects";

  constructor(private http: HttpClient) { }

  orderDownloadSearch(query, Page: any, size: any, sort: any): Observable<Object> {
    return this.http.get(`${this.url5}/filter?search=${query}&page=${Page}&size=${size}&sort=${sort}`);

  }

  orderDownload(page: any, size: any, sort: any): Observable<Object> {
    return this.http.get(`${this.url5}?page=${page}&size=${size}&sort=${sort}`);
  }


  orderDownloadProduct(page: any, size: any, sort: any): Observable<Object> {
    return this.http.get(`${this.url6}?page=${page}&size=${size}&sort=${sort}`);
  }


  orderDownloadProductSearch(query, Page: any, size: any, sort: any): Observable<Object> {
    return this.http.get(`${this.url6}/filter?search=${query}&page=${Page}&size=${size}&sort=${sort}`);

  }

  orderDownloadGstDetails(query, Page: any, size: any, sort: any): Observable<Object> {
    return this.http.get(`${this.url7}/filter?search=${query}&page=${Page}&size=${size}&sort=${sort}`);
  }

  orderGstDownload(page: any, size: any, sort: any): Observable<Object> {
    return this.http.get(`${this.url7}?page=${page}&size=${size}&sort=${sort}`);
  }

  builderDownloadSearch(query, Page: any, size: any, sort: any): Observable<Object> {
    return this.http.get(`${this.url16}/filter?search=${query}&page=${Page}&size=${size}&sort=${sort}`);

  }
  builderDownload(page: any, size: any, sort: any): Observable<Object> {
    return this.http.get(`${this.url16}?page=${page}&size=${size}&sort=${sort}`);
  }

  HousingbuilderDownloadSearch(query, Page: any, size: any, sort: any): Observable<Object> {
    return this.http.get(`${this.url17}/filter?search=${query}&page=${Page}&size=${size}&sort=${sort}`);

  }
  housinhbuilderDownload(page: any, size: any, sort: any): Observable<Object> {
    return this.http.get(`${this.url17}?page=${page}&size=${size}&sort=${sort}`);
  }

  HousinglocationDownloadSearch(query, Page: any, size: any, sort: any): Observable<Object> {
    return this.http.get(`${this.url18}/filter?search=${query}&page=${Page}&size=${size}&sort=${sort}`);

  }
  housinhlocationDownload(page: any, size: any, sort: any): Observable<Object> {
    return this.http.get(`${this.url18}?page=${page}&size=${size}&sort=${sort}`);
  }

  SupplierDownloadSearch(query, Page: any, size: any, sort: any): Observable<Object> {
    return this.http.get(`${this.url19}/filter?search=${query}&page=${Page}&size=${size}&sort=${sort}`);

  }
  supplierDownload(page: any, size: any, sort: any): Observable<Object> {
    return this.http.get(`${this.url19}?page=${page}&size=${size}&sort=${sort}`);
  }

  LoanNoWiseReportDownloadSearch(query, Page: any, size: any, sort: any): Observable<Object> {
    return this.http.get(`${this.url25}/filter?search=${query}&page=${Page}&size=${size}&sort=${sort}`);

  }
  LoanNoWiseReportDownload(page: any, size: any, sort: any): Observable<Object> {
    return this.http.get(`${this.url25}/download?page=${page}&size=${size}&sort=${sort}`);
  }

  usersDownloadSearch(query, Page: any, size: any, sort: any): Observable<Object> {
    return this.http.get(`${this.url20}/filter?search=${query}&page=${Page}&size=${size}&sort=${sort}`);

  }
  usersDownload(page: any, size: any, sort: any): Observable<Object> {
    return this.http.get(`${this.url20}?page=${page}&size=${size}&sort=${sort}`);
  }

  userMailConfigDownloadSearch(query, Page: any, size: any, sort: any): Observable<Object> {
    return this.http.get(`${this.url26}/filter?search=${query}&page=${Page}&size=${size}&sort=${sort}`);

  }
  UserMailConfigDownload(page: any, size: any, sort: any): Observable<Object> {
    return this.http.get(`${this.url26}?page=${page}&size=${size}&sort=${sort}`);
  }

  hrmProjectDownloadSearch(query, Page: any, size: any, sort: any): Observable<Object> {
    return this.http.get(`${this.url27}/filter?search=${query}&page=${Page}&size=${size}&sort=${sort}`);

  }
  hrmProjectDownload(page: any, size: any, sort: any): Observable<Object> {
    return this.http.get(`${this.url27}?page=${page}&size=${size}&sort=${sort}`);
  }



}
